import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace DocumentTypesFields {
  export enum CommonField {
    DenyNotEmptyDocTypeSelection = 'DocumentTypes.DenyNotEmptyDocTypeSelection',
    EnableDocTypeAutoDetection = 'DocumentTypes.EnableDocTypeAutoDetection',
    DocTypeSortingOrder = 'DocumentTypes.DocTypeSortingOrder',
    DocTypeNamingSeparator = 'DocumentTypes.DocTypeNamingSeparator',
    UseCentralDocumentTypeStorage = 'DocumentTypes.UseCentralDocumentTypeStorage',
    AllowAdminEditDocumentTypes = 'DocumentTypes.AllowAdminEditDocumentTypes',
    AllowModifyDefaultValues = 'DocumentTypes.AllowModifyDefaultFieldValues',
  }
}

class CommonConfig extends SettingsSubModule {
  @SettingsSubModule.value(DocumentTypesFields.CommonField.DenyNotEmptyDocTypeSelection, false)
  denyNotEmptyDocTypeSelection: SettingValue<boolean>;
  @SettingsSubModule.value(DocumentTypesFields.CommonField.EnableDocTypeAutoDetection, false)
  enableDocTypeAutoDetection: SettingValue<boolean>;
  @SettingsSubModule.value(DocumentTypesFields.CommonField.DocTypeSortingOrder, 0)
  docTypeSortingOrder: SettingValue<number>;
  @SettingsSubModule.value(DocumentTypesFields.CommonField.DocTypeNamingSeparator, '_')
  docTypeNamingSeparator: SettingValue<string>;
  @SettingsSubModule.value(DocumentTypesFields.CommonField.UseCentralDocumentTypeStorage, false)
  useCentralDocumentTypeStorage: SettingValue<boolean>;
  @SettingsSubModule.value(DocumentTypesFields.CommonField.AllowAdminEditDocumentTypes, true)
  allowAdminEditDocumentTypes: SettingValue<boolean>;
  @SettingsSubModule.value(DocumentTypesFields.CommonField.AllowModifyDefaultValues, false)
  allowModifyDefaultValues: SettingValue<boolean>;
}

export class DocumentTypesModule extends SettingsModule {
  @SettingsModule.value(CommonConfig) common: CommonConfig;
}
